module.exports = __webpack_public_path__ + "assets/img/marlin.8aa2e480.png";